import { render, staticRenderFns } from "./not-in-stock.vue?vue&type=template&id=16ed5968&scoped=true"
import script from "./not-in-stock.vue?vue&type=script&lang=js"
export * from "./not-in-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed5968",
  null
  
)

export default component.exports